// Libellés français harmonisés pour les statuts affichés (chips, listes, etc.).
// Les accords de genre suivent l'entité : candidature/activité (féminin),
// poste (masculin), paiement, école, utilisateur.

export function candidatureStatusLabel(status?: string): string {
  switch (status) {
    case 'approved':
      return 'Approuvée';
    case 'rejected':
      return 'Rejetée';
    case 'pending':
      return 'En attente';
    default:
      return status || 'En attente';
  }
}

export function postStatusLabel(status?: string): string {
  switch (status) {
    case 'approved':
      return 'Approuvé';
    case 'rejected':
      return 'Rejeté';
    case 'pending':
      return 'En attente';
    default:
      return status || 'En attente';
  }
}

export function activityStatusLabel(status?: string): string {
  switch (status) {
    case 'validated':
      return 'Validée';
    case 'rejected':
      return 'Rejetée';
    case 'pending':
      return 'En attente';
    default:
      return status || 'En attente';
  }
}

export function paymentStatusLabel(status?: string): string {
  switch (status) {
    case 'paid':
      return 'Payé';
    case 'pending':
      return 'En attente';
    default:
      return status || 'En attente';
  }
}

export function schoolStatusLabel(status?: string): string {
  switch (status) {
    case 'inactive':
      return 'Inactive';
    case 'active':
      return 'Active';
    default:
      return status || 'Active';
  }
}

export function userStatusLabel(status?: string): string {
  switch (status) {
    case 'inactive':
      return 'Inactif';
    case 'active':
      return 'Actif';
    default:
      return status || 'Actif';
  }
}
